import ApiClient from '@/ApiClient/ApiClient'
import { MediaServices } from '@/services/media/Media.services'

export interface ProcessFileEntity {
  id: number
  createdAt: string
  updatedAt: string
  process_state_id: number
  file_path: string
}

/**
 * Recupera un file e gestisce diverse modalità di risposta.
 * Utilizza internamente MediaServices.getMediaFile() con source='user_media' per unificare la gestione dei file.
 *
 * @param id - ID del file
 * @param mode - Modalità ('url', 'download', 'auto', 'blob')
 * @returns Oggetto con url, tipo o blob a seconda della modalità
 */
export const FilesService = {
  async getFiles(
    id: number,
    mode: 'url' | 'download' | 'auto' | 'blob' = 'url'
  ): Promise<{ url: string; type: string } | { type: string } | { blob: Blob; type: string }> {
    // Utilizza MediaServices.getMediaFile() con source='user_media' per unificare la gestione
    return MediaServices.getMediaFile(id, mode, 'user_media')
  },

  /**
   * Ottiene solo il nome del file senza scaricarlo.
   * Utilizza una richiesta HEAD per ottenere solo gli header.
   *
   * @param id - ID del file
   * @returns Nome del file estratto dall'header Content-Disposition
   */
  async getFileName(id: number): Promise<string> {
    return MediaServices.getMediaFileName(id, 'user_media')
  },

  async deleteFile(id: string) {
    const response = await ApiClient.delete(`/process-file/${id}`)
    return response
  },

  async uploadFile(file: File, processStateId: string) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('process_state_id', processStateId)
    const response = await ApiClient.post<ProcessFileEntity>(`/process-file/upload`, formData)
    return response
  },
}
